import { QueryClient } from '@tanstack/react-query'

// Covers both axios errors (error.response.status) and the generated fetch
// client, which throws the HTTP response itself (error.status).
const getErrorStatus = (error: unknown): number | undefined => {
  const err = error as {
    response?: { status?: number }
    status?: number
  } | null

  return err?.response?.status ?? err?.status
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // 4xx responses (401/403/404…) are deterministic — retrying them only
      // multiplies forbidden/unauthorized requests. Retry transient failures
      // (network, 5xx) once.
      retry: (failureCount, error) => {
        const status = getErrorStatus(error)

        if (status && status >= 400 && status < 500) {
          return false
        }

        return failureCount < 2
      },
    },
  },
})
